(function () {
  var config = window.AFWhatsappSellerRouting || {};
  var sellerStorageKey = 'af_whatsapp_seller_order';
  var sellerSourceStorageKey = 'af_whatsapp_seller_source';
  var nextSellerStorageKey = 'af_whatsapp_next_seller_index';
  var routerEndpoint = String(config.routerEndpoint || '').trim();
  var sellers = normalizeSellers(config.sellersJson);

  if (!sellers.length) {
    return;
  }

  captureSellerFromUrl();
  downloadCartTextFromUrl();
  updateWhatsappLinks();
  bindWhatsappClicks();
  observeWhatsappLinks();

  function normalizeSellers(sellersJson) {
    var parsedSellers;

    try {
      parsedSellers = JSON.parse(sellersJson || '[]');
    } catch (error) {
      parsedSellers = [];
    }

    if (!Array.isArray(parsedSellers)) {
      return [];
    }

    return parsedSellers
      .map(function (seller, index) {
        var order = Number(seller.ordem || seller.order || seller.ord || index + 1);
        var phone = String(seller.whatsapp || seller.phone || '').replace(/\D/g, '');

        return {
          name: seller.nome || seller.name || '',
          phone: phone,
          order: order
        };
      })
      .filter(function (seller) {
        return seller.phone && seller.order > 0;
      })
      .sort(function (a, b) {
        return a.order - b.order;
      });
  }

  function captureSellerFromUrl() {
    var url = new URL(window.location.href);
    var sellerOrder = url.searchParams.get('v');
    var pathMatch = window.location.pathname.match(/^\/(\d+)\/?$/);

    if (!sellerOrder && pathMatch) {
      sellerOrder = pathMatch[1];
    }

    if (sellerOrder && (routerEndpoint || findSeller(sellerOrder))) {
      setStoredSellerOrder(sellerOrder);
      setStoredSellerSource('link');

      if (pathMatch) {
        window.location.replace('/?v=' + encodeURIComponent(sellerOrder));
      }
    }
  }

  function downloadCartTextFromUrl() {
    var url = new URL(window.location.href);
    var code = normalizeCartTextRequestCode(url.searchParams.get('ctxt') || '');

    if (!code && url.hash) {
      code = normalizeCartTextRequestCode(url.hash);
    }

    if (!code || !routerEndpoint) {
      return;
    }

    var downloadUrl = getRouterCartTextUrl(code);
    var downloadLink = document.createElement('a');
    downloadLink.href = downloadUrl;
    downloadLink.download = code + '.txt';
    downloadLink.style.display = 'none';
    document.documentElement.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  }

  function updateWhatsappLinks() {
    var selectedSeller = getLinkedSeller();

    if (!selectedSeller || !selectedSeller.phone) {
      return;
    }

    document.querySelectorAll('[data-whatsapp-seller-link]').forEach(function (link) {
      updateWhatsappLink(link, selectedSeller);
    });

    saveSellerOnCart(selectedSeller);
  }

  function bindWhatsappClicks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-whatsapp-seller-link]');

      if (!link) {
        return;
      }

      var linkedSeller = getLinkedSeller();

      if (routerEndpoint && window.fetch) {
        event.preventDefault();
        routeWithBackend(link, linkedSeller);
        return;
      }

      var selectedSeller = linkedSeller || getNextSeller();

      if (!selectedSeller) {
        return;
      }

      updateWhatsappLink(link, selectedSeller, createFallbackCartInfo());
      saveSellerOnCart(selectedSeller);
    }, true);
  }

  function routeWithBackend(link, linkedSeller) {
    if (link.dataset.whatsappSellerLoading === 'true') {
      return;
    }

    link.dataset.whatsappSellerLoading = 'true';

    var openedWindow = link.target === '_blank' ? window.open('', '_blank') : null;

    getBackendSeller(linkedSeller)
      .then(function (seller) {
        return createCartText(seller, getWhatsappText(link.href)).catch(function () {
          return createFallbackCartInfo();
        }).then(function (cartInfo) {
          return {
            seller: seller,
            cartInfo: cartInfo
          };
        });
      })
      .then(function (result) {
        if (!result.seller) {
          throw new Error('Router seller error');
        }

        updateWhatsappLink(link, result.seller, result.cartInfo);
        saveSellerOnCart(result.seller);
        openWhatsappLink(link.href, openedWindow, link.target);
      })
      .catch(function () {
        var fallbackSeller = (linkedSeller && linkedSeller.phone ? linkedSeller : null) || getNextSeller();
        updateWhatsappLink(link, fallbackSeller, createFallbackCartInfo());
        saveSellerOnCart(fallbackSeller);
        openWhatsappLink(link.href, openedWindow, link.target);
      })
      .finally(function () {
        link.dataset.whatsappSellerLoading = 'false';
      });
  }

  function getBackendSeller(linkedSeller) {
    if (linkedSeller && linkedSeller.phone) {
      return Promise.resolve(linkedSeller);
    }

    return fetch(routerEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        action: linkedSeller && linkedSeller.order ? 'seller' : 'next',
        ordem: linkedSeller && linkedSeller.order ? linkedSeller.order : undefined,
        cart_token: getCartToken()
      })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Router response error');
        }

        return response.json();
      })
      .then(function (payload) {
        var seller = normalizeBackendSeller(payload && payload.seller);

        if (!seller) {
          throw new Error('Router seller error');
        }

        return seller;
      });
  }

  function createCartText(seller, whatsappText) {
    var whatsappItems = parseWhatsappItems(whatsappText);

    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart response error');
        }

        return response.json();
      })
      .then(function (cart) {
        return fetch(routerEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            action: 'cart_text',
            cart_token: cart.token || getCartToken(),
            seller_order: seller.order,
            items: (cart.items || []).map(function (item) {
              var whatsappItem = whatsappItems.shift() || {};

              return {
                ean: whatsappItem.ean || '',
                codigo: whatsappItem.ean || '',
                nome: item.product_title || item.title || '',
                quantidade: whatsappItem.quantity || item.quantity || 1
              };
            })
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart text response error');
        }

        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.cart || !payload.cart.code) {
          return createFallbackCartInfo();
        }

        return {
          code: normalizeCartCode(payload.cart.code),
          url: getCartTextUrl(payload.cart.code)
        };
      });
  }

  function parseWhatsappItems(text) {
    if (!text) {
      return [];
    }

    return text.split(/\n+/).map(function (block) {
      var itemMatch = block.match(/^\s*(.+?)\s+(?:\u2014|-)\s+.*(?:\u2014|-)\s+(\d+)\s+unidade/i);
      var eanMatch = block.match(/EAN:\s*([^\n\r]+)/i);
      var quantityMatch = block.match(/Quantidade:\s*(\d+)/i);

      return {
        ean: itemMatch ? itemMatch[1].trim() : (eanMatch ? eanMatch[1].trim() : ''),
        quantity: itemMatch ? Number(itemMatch[2]) : (quantityMatch ? Number(quantityMatch[1]) : 0)
      };
    }).filter(function (item) {
      return item.ean || item.quantity;
    });
  }

  function createFallbackCartInfo() {
    return {
      code: generateCartCode()
    };
  }

  function generateCartCode() {
    return 'AF-' + String(Math.floor(10000 + Math.random() * 90000));
  }

  function normalizeCartCode(code) {
    code = String(code || '');

    if (/^AF-\d{5}$/.test(code)) {
      return code;
    }

    var digits = code.replace(/\D/g, '').slice(-5);

    if (digits.length === 5) {
      return 'AF-' + digits;
    }

    return generateCartCode();
  }

  function normalizeBackendSeller(seller) {
    if (!seller) {
      return null;
    }

    var order = Number(seller.ordem || seller.order);
    var phone = String(seller.whatsapp || seller.phone || '').replace(/\D/g, '');

    if (!order || !phone) {
      return null;
    }

    return {
      name: seller.nome || seller.name || '',
      phone: phone,
      order: order
    };
  }

  function openWhatsappLink(href, openedWindow, target) {
    if (openedWindow) {
      openedWindow.location.href = href;
      return;
    }

    if (target === '_blank') {
      window.open(href, '_blank', 'noopener');
      return;
    }

    window.location.href = href;
  }

  function updateWhatsappLink(link, seller, cartInfo) {
    var text = link.dataset.whatsappBaseText || getWhatsappText(link.href);

    if (!text) {
      return;
    }

    link.dataset.whatsappBaseText = text;

    if (cartInfo && cartInfo.code) {
      text += '\nCarrinho: #' + cartInfo.code;
    }

    link.href = 'https://wa.me/' + seller.phone + '?text=' + encodeURIComponent(text);
    link.dataset.whatsappSellerOrder = seller.order;
    if (seller.name) {
      link.dataset.whatsappSellerName = seller.name;
    }
  }

  function getWhatsappText(href) {
    try {
      return new URL(href, window.location.origin).searchParams.get('text') || '';
    } catch (error) {
      return '';
    }
  }

  function getNextSeller() {
    var nextIndex = getNextSellerIndex();
    var seller = sellers[nextIndex % sellers.length];
    setNextSellerIndex((nextIndex + 1) % sellers.length);

    return seller;
  }

  function getCartToken() {
    try {
      return window.localStorage.getItem('cart') || '';
    } catch (error) {
      return '';
    }
  }

  function getCartTextUrl(code) {
    var url = new URL(window.location.origin);
    url.searchParams.set('ctxt', normalizeCartTextRequestCode(code));
    return url.toString();
  }

  function getRouterCartTextUrl(code) {
    try {
      var url = new URL(routerEndpoint, window.location.origin);
      url.searchParams.set('ctxt', normalizeCartTextRequestCode(code));
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function normalizeCartTextRequestCode(code) {
    return String(code || '').replace(/^#/, '').trim();
  }

  function getLinkedSeller() {
    if (getStoredSellerSource() !== 'link') {
      return null;
    }

    var storedOrder = getStoredSellerOrder();
    var seller = findSeller(storedOrder);

    if (seller) {
      return seller;
    }

    storedOrder = Number(storedOrder);

    if (routerEndpoint && storedOrder > 0) {
      return {
        name: '',
        phone: '',
        order: storedOrder
      };
    }

    return null;
  }

  function findSeller(order) {
    order = Number(order);

    return sellers.find(function (seller) {
      return seller.order === order;
    });
  }

  function getStoredSellerOrder() {
    try {
      return window.localStorage.getItem(sellerStorageKey);
    } catch (error) {
      return '';
    }
  }

  function setStoredSellerOrder(order) {
    try {
      window.localStorage.setItem(sellerStorageKey, String(order));
    } catch (error) {}
  }

  function getStoredSellerSource() {
    try {
      return window.localStorage.getItem(sellerSourceStorageKey);
    } catch (error) {
      return '';
    }
  }

  function setStoredSellerSource(source) {
    try {
      window.localStorage.setItem(sellerSourceStorageKey, source);
    } catch (error) {}
  }

  function getNextSellerIndex() {
    try {
      var index = Number(window.localStorage.getItem(nextSellerStorageKey));
      return Number.isFinite(index) && index >= 0 ? index : 0;
    } catch (error) {
      return 0;
    }
  }

  function setNextSellerIndex(index) {
    try {
      window.localStorage.setItem(nextSellerStorageKey, String(index));
    } catch (error) {}
  }

  function saveSellerOnCart(seller) {
    if (!window.fetch || saveSellerOnCart.savedOrder === seller.order) {
      return;
    }

    saveSellerOnCart.savedOrder = seller.order;
    window.fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Vendedor WhatsApp': seller.name || String(seller.order),
          'Ordem vendedor WhatsApp': String(seller.order),
          'WhatsApp vendedor': seller.phone
        }
      })
    }).catch(function () {});
  }

  function observeWhatsappLinks() {
    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(function () {
      updateWhatsappLinks();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
